var blobStorage = 'https://accoblobstorageus.blob.core.windows.net/assets/images/shredderSelector/';

var shredderSelectorExtra1 = $(".shredderSelectorExtra1").text();
var shredderSelectorExtra2 = $(".shredderSelectorExtra2").text();
var shredderSelectorExtra3 = $(".shredderSelectorExtra3").text();
var shredderSelectorExtra4 = $(".shredderSelectorExtra4").text();
var shredderSelectorExtra5 = $(".shredderSelectorExtra5").text();
var shredderSelectorExtra6 = $(".shredderSelectorExtra6").text();
var shredderSelectorExtra7 = $(".shredderSelectorExtra7").text();
var shredderSelectorExtra8 = $(".shredderSelectorExtra8").text();
var shredderSelectorExtra9 = $(".shredderSelectorExtra9").text();
var shredderSelectorExtra10 = $(".shredderSelectorExtra10").text();
var shredderSelectorExtra11 = $(".shredderSelectorExtra11").text();
var shredderSelectorExtra12 = $(".shredderSelectorExtra12").text();
var shredderSelectorExtra13 = $(".shredderSelectorExtra13").text();
var shredderSelectorExtra14 = $(".shredderSelectorExtra14").text();
var shredderSelectorExtra15 = $(".shredderSelectorExtra15").text();
var shredderSelectorExtra16 = $(".shredderSelectorExtra16").text();
var shredderSelectorExtra17 = $(".shredderSelectorExtra17").text();
var shredderSelectorExtra18 = $(".shredderSelectorExtra18").text();
var shredderSelectorExtra19 = $(".shredderSelectorExtra19").text();
var shredderSelectorExtra20 = $(".shredderSelectorExtra20").text();
var shredderSelectorExtra21 = $(".shredderSelectorExtra21").text();

$(document).ready(function () {
    // $.getJSON("http://devsite2.mbdev.co.uk/ajax/shredderSelectorJSON.ashx?country=gb&language=en", callbackFuncWithData); // Fetch the JSON file with getJSON ajax call
    // 	console.log($.parseJSON($(".JSONdata").text()));
    // console.log($(".JSONdata").text());
    callbackFuncWithData($.parseJSON($(".JSONdata").text()));
});

// http://devsite1.accodev.com/ajax/shredderSelectorJSON.ashx?country=gb&language=en
// http://devsite2.mbdev.co.uk/ajax/shredderSelectorJSON.ashx?country=gb&language=en
// js/shredderSelectorJSON.json

function callbackFuncWithData(data) { // Then do stuff with the returning JSON.data

    // Set debugging value (I was tired of commenting out logs)
    var debugging = 0;

    // Grab the products in data.json, wrapped in a variable
    var filteredData = data.products;

    // First run some initial checks on the data
    var initialData = data.products;

    var q1InitialA = 0;
    var q1InitialB = 0;
    var q1InitialC = 0;
    var q1InitialD = 0;
    var q1InitialE = 0;

    $(initialData).each(function (i) {
        if (($.inArray("a", this.q1)) >= 0) {
            q1InitialA++;
        } if (($.inArray("b", this.q1)) >= 0) {
            q1InitialB++;
        } if (($.inArray("c", this.q1)) >= 0) {
            q1InitialC++;
        } if (($.inArray("d", this.q1)) >= 0) {
            q1InitialD++;
        } if (($.inArray("e", this.q1)) >= 0) {
            q1InitialE++;
        }
    });

    if (debugging == 1) {
        console.log("q1InitialA: " + q1InitialA);
        console.log("q1InitialB: " + q1InitialB);
        console.log("q1InitialC: " + q1InitialC);
        console.log("q1InitialD: " + q1InitialD);
        console.log("q1InitialE: " + q1InitialE);
    }

    // If any of the initial values are zero, then we want to disable the equivalent choices off the bat
    if (q1InitialA == "0") {
        $("#1a").addClass('disabled');
    }
    if (q1InitialB == "0") {
        $("#1b").addClass('disabled');
    }
    if (q1InitialC == "0") {
        $("#1c").addClass('disabled');
    }
    if (q1InitialD == "0") {
        $("#1d").addClass('disabled');
    }
    if (q1InitialE == "0") {
        $("#1e").addClass('disabled');
    }

    // Tool tip on various disabled buttons (http://jqueryui.com/tooltip/) //
    $('body').tooltip({
        items: ".next-disabled:not(.submit), .disabled, .submit.next-disabled, .product-data img, #2a, #2b, #1a.disabled, #1b.disabled, #1c.disabled, #1d.disabled, #1e.disabled",
        content: function () {
            var element = $(this);
            if (element.is(".next-disabled:not(.submit)")) { // Disabled 'next' button
                return shredderSelectorExtra1;
            }
            if (element.is(".disabled:not(#1a, #1b, #1c, #1d, #1e)")) {
                return shredderSelectorExtra2;
            }
            if (element.is("#1a.disabled, #1b.disabled, #1c.disabled, #1d.disabled, #1e.disabled")) {
                return shredderSelectorExtra3;
            }
            if (element.is(".submit.next-disabled")) { // Disabled 'submit' button
                return shredderSelectorExtra4;
            }
            if (element.is(".product-data img")) {
                return element.attr("alt"); // Image alt text shown for product-icons
            }
            if (element.is("#2a")) {
                return shredderSelectorExtra5;
            }
            if (element.is("#2b")) {
                return shredderSelectorExtra6;
            }
        },
        position: {
            my: "center bottom",
            at: "center top"
        }
    });

    // Hotspot tooltips, for the 'highlights' page (only works on click)
    $(".hotspot")
	  .tooltip({
	      content: function () {
	          var element = $(this);
	          return element.html();
	      },
	      items: 'div',
	      position: {
	          my: "center bottom",
	          at: "center top"
	      },
	      tooltipClass: 'hotspot-tooltip'
	  })
	  .off("mouseover")
	  .on("click", function () {
	      $(this).tooltip("open");
	      return false;
	  })
	  .attr("value", "").css({ cursor: "pointer" });


    // Smooth 'back to top' anchor scrolling
    $('a[href*=#]:not([href=#])').click(function () {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top
                }, 1000);
                return false;
            }
        }
    });

    // Go to next slide function //
    function goToNextSlide() {
        $('#slides-container').css('left', '-=960px'); // 960px is the width of one slide
    }

    // Go to next slide handler //
    $('body').on('click', '.next:not(.submit)', function () {
        goToNextSlide();
    });

    // Go to previous slide function //
    // function goToPreviousSlide(el) {
    // 	var slideParent = $(el).parent().parent();
    // 	var slideParentID = slideParent.attr('id');
    // 	slideParent.children().removeClass("selected"); // Removes any selected choices from this slide
    // 	slideParent.children().removeClass("disabled"); // Removes any disabled choices from this slide
    // 	$("#" + slideParentID + " .back-next-container .next").removeClass('next').addClass('next-disabled'); // Disable the next button
    // 	$('#slides-container').css('left', '+=960px'); // 960px is the width of one slide
    // }

    // Go to previous slide handler //
    $('.start-over').click(function () {
        // goToPreviousSlide(this);
        location.reload(); // Just reload the page, rather than going back - much easier!
    });

    // .Submit button //
    $('.submit').click(function () {
        $('#selector-wrap').css({ 'visibility': 'hidden', 'opacity': '0' });
        $('#results-wrap').css({ 'visibility': 'visible', 'opacity': '1' });
        $('#selector-wrap').css('display', 'none');
        updateCounter();
        populateContent();
    });

    // Set question variables to null globally //
    var questionOne = "",
		questionTwo = "",
		questionThree = "";

    // Slide one click handler //
    $('body').on('click', '#slide-1 .choice', function () {
        questionOne = $(this).attr('id'); // Set the question variable
        firstLogic();
    });

    var filteredDataAfterQ2;

    // Slide two click handler //
    $('body').on('click', '#slide-2 .choice', function () {
        questionTwo = $(this).attr('id');
        secondLogic();
    });

    // Slide three click handler //
    $('body').on('click', '#slide-3 .choice', function () {
        if ($(this).hasClass('selected')) {
            //console.log("selected");
            if (debugging == 1) { console.log('You unselected a Q3'); }
            filteredData = filteredDataAfterQ2; // If we've unselected a Q3 choice, then roll back to the data as it was at the end of Q2
            questionThree = ""; // And clear the questionThree variable
        } else {
            //console.log("not selected");
            questionThree = $(this).attr('id');
            thirdLogic();
            // 'Submit' function is further up!
        }
    });

    // All the click handlers use the on() method
    // This is so that it can listen to jquery inserted class names
    // Rather than just classes that are set in the DOM on page load.

    // .Selected option click handler
    $('body').on('click', '.choice:not(.disabled)', function () {
        var parent = $(this).parent().attr('id');

        if ($(this).hasClass("selected")) {
            $(this).removeClass("selected");
            $("#" + parent + " .back-next-container .next").removeClass('next').addClass('next-disabled');
        } else if (parent !== 'slide-3') {
            $(this).parent().children().removeClass("selected");
            $(this).addClass("selected");
            goToNextSlide(); // Only auto progress to next slide if not last slide!
            $("#" + parent + " .back-next-container .next-disabled").removeClass('next-disabled').addClass('next');
        } else {
            $(this).parent().children().removeClass("selected");
            $(this).addClass("selected");
            $("#" + parent + " .back-next-container .next-disabled").removeClass('next-disabled').addClass('next');
        }
    });

    function firstLogic() {
        if (debugging == 1) { console.log("Question one: " + questionOne); }

        // Whittle down the full pack
        if (questionOne == "1a") {
            filteredData = $.grep(filteredData, function (n) {
                return n.q1 == 'a';
            });
        } else if (questionOne == "1b") {
            filteredData = $.grep(filteredData, function (n) {
                return n.q1 == 'b';
            });
        } else if (questionOne == "1c") {
            filteredData = $.grep(filteredData, function (n) {
                return n.q1 == 'c';
            });
        } else if (questionOne == "1d") {
            filteredData = $.grep(filteredData, function (n) {
                return n.q1 == 'd';
            });
        }

        if (debugging == 1) { console.log("Remaining shredders: " + filteredData.length); }

        var q2RemainingA = 0;
        var q2RemainingB = 0;
        var q2RemainingC = 0;
        var q2RemainingD = 0;
        var q2RemainingE = 0;
        var q2RemainingF = 0;

        $(filteredData).each(function (i) {
            if (($.inArray("a", this.q2)) >= 0) {
                q2RemainingA++;
            } if (($.inArray("b", this.q2)) >= 0) {
                q2RemainingB++;
            } if (($.inArray("c", this.q2)) >= 0) {
                q2RemainingC++;
            } if (($.inArray("d", this.q2)) >= 0) {
                q2RemainingD++;
            } if (($.inArray("e", this.q2)) >= 0) {
                q2RemainingE++;
            } if (($.inArray("f", this.q2)) >= 0) {
                q2RemainingF++;
            }
        });

        if (debugging == 1) {
            console.log("Remaining 2a: " + q2RemainingA);
            console.log("Remaining 2b: " + q2RemainingB);
            console.log("Remaining 2c: " + q2RemainingC);
            console.log("Remaining 2d: " + q2RemainingD);
            console.log("Remaining 2e: " + q2RemainingE);
        }

        // Disable the slide-2 buttons that have no remaining shredders
        if (q2RemainingA == "0") {
            $("#2a").addClass('disabled');
        }
        if (q2RemainingB == "0") {
            $("#2b").addClass('disabled');
        }
        if (q2RemainingC == "0") { // This isn't right, because 2c is 'I don't mind' rather than an actual value
            $("#2c").addClass('disabled');
        }
        if (q2RemainingD == "0") {
            $("#2d").addClass('disabled');
        }
        if (q2RemainingE == "0") {
            $("#2e").addClass('disabled');
        }

    }

    function secondLogic() {
        if (debugging == 1) { console.log("Question two: " + questionTwo); }

        // Whittle down the remaining pack
        if (questionTwo == "2a") {
            filteredData = $.grep(filteredData, function (n) {
                return n.q2 == 'a';
            });
        } else if (questionTwo == "2b") {
            filteredData = $.grep(filteredData, function (n) {
                return n.q2 == 'b';
            });
        } else if (questionTwo == "2c") {
            filteredData = $.grep(filteredData, function (n) {
                return n.q2 == 'c';
            });
        }

        if (debugging == 1) { console.log("Remaining shredders: " + filteredData.length); }

        var q3RemainingA = 0;
        var q3RemainingB = 0;
        var q3RemainingC = 0;
        var q3RemainingD = 0;
        var q3RemainingE = 0;
        var q3RemainingF = 0;

        $(filteredData).each(function (i) {
            if (($.inArray("a", this.q3)) >= 0) {
                q3RemainingA++;
            } if (($.inArray("b", this.q3)) >= 0) {
                q3RemainingB++;
            } if (($.inArray("c", this.q3)) >= 0) {
                q3RemainingC++;
            } if (($.inArray("d", this.q3)) >= 0) {
                q3RemainingD++;
            } if (($.inArray("e", this.q3)) >= 0) {
                q3RemainingE++;
            } if (($.inArray("f", this.q3)) >= 0) {
                q3RemainingF++;
            }
        });

        filteredDataAfterQ2 = filteredData;

        if (debugging == 1) {
            console.log("Remaining 3a: " + q3RemainingA);
            console.log("Remaining 3b: " + q3RemainingB);
            console.log("Remaining 3c: " + q3RemainingC);
            console.log("Remaining 3d: " + q3RemainingD);
            console.log("Remaining 3e: " + q3RemainingE);
            console.log("Remaining 3f: " + q3RemainingF);
        }

        // Disable the slide-3 buttons that have no remaining shredders
        if (q3RemainingA == "0") {
            $("#3a").addClass('disabled');
        }
        if (q3RemainingB == "0") {
            $("#3b").addClass('disabled');
        }
        if (q3RemainingC == "0") {
            $("#3c").addClass('disabled');
        }
        if (q3RemainingD == "0") {
            $("#3d").addClass('disabled');
        }
        if (q3RemainingE == "0") {
            $("#3e").addClass('disabled');
        }
        if (q3RemainingF == "0") {
            $("#3f").addClass('disabled');
        }

    }

    function thirdLogic() {
        if (debugging == 1) { console.log("Question three: " + questionThree); }

        if (questionThree == "3a") {
            filteredData = $.grep(filteredData, function (n) {
                return (n.q3[0] == 'a' || n.q3[1] == 'a')
            });
        } else if (questionThree == "3b") {
            filteredData = $.grep(filteredData, function (n) {
                return (n.q3[0] == 'b' || n.q3[1] == 'b')
            });
        } else if (questionThree == "3c") {
            filteredData = $.grep(filteredData, function (n) {
                return (n.q3[0] == 'c' || n.q3[1] == 'c')
            });
        } else if (questionThree == "3d") {
            filteredData = $.grep(filteredData, function (n) {
                return (n.q3[0] == 'd' || n.q3[1] == 'd')
            });
        } else if (questionThree == "3e") {
            filteredData = $.grep(filteredData, function (n) {
                return (n.q3[0] == 'e' || n.q3[1] == 'e')
            });
        } else if (questionThree == "3f") {
            filteredData = $.grep(filteredData, function (n) {
                return (n.q3[0] == 'f' || n.q3[1] == 'f')
            });
        }

        if (debugging == 1) { console.log("Remaining shredders: " + filteredData.length); }
    }

    // Set the text for the number of shredders found
    function updateCounter() {
        var dataLength = filteredData.length;
        $('#the-count').append(filteredData.length);
    }

    // Loop over remaining products and populate DOM
    function populateContent() {
        if (debugging == 1) { console.log(filteredData); }
        $(filteredData).each(function () {

            var output = "<div class='shredder-suggestion'><div class='product-image float-left'><img src='" + this.imageURL + "' /></div><div class='product-data float-right'><h4 id='shredder-name'>" + this.productName + "</h4><div class='security-icons'>";

            // Check to see what the security level is, in reverse order so highest badge always shown!
            if (this.q3[0] == 'f' || this.q3[1] == 'f') {
                output += "<img src='" + blobStorage + "security-icons/7.svg' alt='" + shredderSelectorExtra7 + "' /><img src='" + blobStorage + "cut-type-icons/super-fine-micro.svg' alt='" + shredderSelectorExtra13 + "' />";
            } else if (this.q3[0] == 'e' || this.q3[1] == 'e') {
                output += "<img src='" + blobStorage + "security-icons/6.svg' alt='" + shredderSelectorExtra8 + "' /><img src='" + blobStorage + "cut-type-icons/super-fine-micro.svg' alt='" + shredderSelectorExtra13 + "' />";
            } else if (this.q3[0] == 'd' || this.q3[1] == 'd') {
                output += "<img src='" + blobStorage + "security-icons/5.svg' alt='" + shredderSelectorExtra9 + "' /><img src='" + blobStorage + "cut-type-icons/micro-super.svg' alt='" + shredderSelectorExtra14 + "' />";
            } else if (this.q3[0] == 'c' || this.q3[1] == 'c') {
                output += "<img src='" + blobStorage + "security-icons/4.svg' alt='" + shredderSelectorExtra10 + "' /><img src='" + blobStorage + "cut-type-icons/micro.svg' alt='" + shredderSelectorExtra15 + "' />";
            } else if (this.q3[0] == 'b' || this.q3[1] == 'b') {
                output += "<img src='" + blobStorage + "security-icons/3.svg' alt='" + shredderSelectorExtra11 + "' /><img src='" + blobStorage + "cut-type-icons/cross.svg' alt='" + shredderSelectorExtra16 + "' />";
            } else if (this.q3 == 'a') {
                output += "<img src='" + blobStorage + "security-icons/2.svg' alt='" + shredderSelectorExtra12 + "' /><img src='" + blobStorage + "cut-type-icons/strip.svg' alt='" + shredderSelectorExtra17 + "' />";
            }

            // Shreds CDs?
            if (this.shredsCDs == 'True') {
                output += "<img src='" + blobStorage + "cd-icon.svg' alt='" + shredderSelectorExtra18 + "' />";
            }

            // Shreds paper clips?
            if (this.shredsPaperClips == 'True') {
                output += "<img src='" + blobStorage + "paperclip-icon.jpg' alt='" + shredderSelectorExtra19 + "' />";
            }

            // Shreds staples?
            if (this.shredsStaples == 'True') {
                output += "<img src='" + blobStorage + "staple-icon.jpg' alt='" + shredderSelectorExtra20 + "' />";
            }

            // Shreds credit cards?
            if (this.shredsCreditCards == 'True') {
                output += "<img src='" + blobStorage + "credit-card-icon.jpg' alt='" + shredderSelectorExtra21 + "' />";
            }

            // Bin capacity
            if (this.binCapacity == '225') { output += "<img src='" + blobStorage + "bin-icons/225.svg' />"; }
            else if (this.binCapacity == '175') { output += "<img src='" + blobStorage + "bin-icons/175.svg' />"; }
            else if (this.binCapacity == '115') { output += "<img src='" + blobStorage + "bin-icons/115.svg' />"; }
            else if (this.binCapacity == '80') { output += "<img src='" + blobStorage + "bin-icons/80.svg' />"; }
            else if (this.binCapacity == '70') { output += "<img src='" + blobStorage + "bin-icons/70.svg' />"; }
            else if (this.binCapacity == '60') { output += "<img src='" + blobStorage + "bin-icons/60.svg' />"; }
            else if (this.binCapacity == '50') { output += "<img src='" + blobStorage + "bin-icons/50.svg' />"; }
            else if (this.binCapacity == '40') { output += "<img src='" + blobStorage + "bin-icons/40.svg' />"; }
            else if (this.binCapacity == '35') { output += "<img src='" + blobStorage + "bin-icons/35.svg' />"; }
            else if (this.binCapacity == '34') { output += "<img src='" + blobStorage + "bin-icons/34.svg' />"; }
            else if (this.binCapacity == '32') { output += "<img src='" + blobStorage + "bin-icons/32.svg' />"; }
            else if (this.binCapacity == '30') { output += "<img src='" + blobStorage + "bin-icons/30.svg' />"; }
            else if (this.binCapacity == '26') { output += "<img src='" + blobStorage + "bin-icons/26.svg' />"; }
            else if (this.binCapacity == '23') { output += "<img src='" + blobStorage + "bin-icons/23.svg' />"; }
            else if (this.binCapacity == '22') { output += "<img src='" + blobStorage + "bin-icons/22.svg' />"; }
            else if (this.binCapacity == '21') { output += "<img src='" + blobStorage + "bin-icons/21.svg' />"; }
            else if (this.binCapacity == '20') { output += "<img src='" + blobStorage + "bin-icons/20.svg' />"; }
            else if (this.binCapacity == '18') { output += "<img src='" + blobStorage + "bin-icons/18.svg' />"; }
            else if (this.binCapacity == '15') { output += "<img src='" + blobStorage + "bin-icons/15.svg' />"; }
            else if (this.binCapacity == '14') { output += "<img src='" + blobStorage + "bin-icons/14.svg' />"; }
            else if (this.binCapacity == '12') { output += "<img src='" + blobStorage + "bin-icons/12.svg' />"; }
            else if (this.binCapacity == '10') { output += "<img src='" + blobStorage + "bin-icons/10.svg' />"; }
            else if (this.binCapacity == '7_5') { output += "<img src='" + blobStorage + "bin-icons/7_5.svg' />"; }

            // Sheet capacity
            if (this.sheetCapacity == '750') { output += "<img src='" + blobStorage + "capacity-icons/750.svg' />"; }
            else if (this.sheetCapacity == '500') { output += "<img src='" + blobStorage + "capacity-icons/500.svg' />"; }
            else if (this.sheetCapacity == '300') { output += "<img src='" + blobStorage + "capacity-icons/300.svg' />"; }
            else if (this.sheetCapacity == '200') { output += "<img src='" + blobStorage + "capacity-icons/200.svg' />"; }
            else if (this.sheetCapacity == '100') { output += "<img src='" + blobStorage + "capacity-icons/100.svg' />"; }
            else if (this.sheetCapacity == '80') { output += "<img src='" + blobStorage + "capacity-icons/80.svg' />"; }
            else if (this.sheetCapacity == '60') { output += "<img src='" + blobStorage + "capacity-icons/60.svg' />"; }
            else if (this.sheetCapacity == '47') { output += "<img src='" + blobStorage + "capacity-icons/47.svg' />"; }
            else if (this.sheetCapacity == '39') { output += "<img src='" + blobStorage + "capacity-icons/39.svg' />"; }
            else if (this.sheetCapacity == '35') { output += "<img src='" + blobStorage + "capacity-icons/35.svg' />"; }
            else if (this.sheetCapacity == '34') { output += "<img src='" + blobStorage + "capacity-icons/34.svg' />"; }
            else if (this.sheetCapacity == '32') { output += "<img src='" + blobStorage + "capacity-icons/32.svg' />"; }
            else if (this.sheetCapacity == '26') { output += "<img src='" + blobStorage + "capacity-icons/26.svg' />"; }
            else if (this.sheetCapacity == '25') { output += "<img src='" + blobStorage + "capacity-icons/25.svg' />"; }
            else if (this.sheetCapacity == '24') { output += "<img src='" + blobStorage + "capacity-icons/24.svg' />"; }
            else if (this.sheetCapacity == '22') { output += "<img src='" + blobStorage + "capacity-icons/22.svg' />"; }
            else if (this.sheetCapacity == '21') { output += "<img src='" + blobStorage + "capacity-icons/21.svg' />"; }
            else if (this.sheetCapacity == '20') { output += "<img src='" + blobStorage + "capacity-icons/20.svg' />"; }
            else if (this.sheetCapacity == '18') { output += "<img src='" + blobStorage + "capacity-icons/18.svg' />"; }
            else if (this.sheetCapacity == '16') { output += "<img src='" + blobStorage + "capacity-icons/16.svg' />"; }
            else if (this.sheetCapacity == '12') { output += "<img src='" + blobStorage + "capacity-icons/12.svg' />"; }
            else if (this.sheetCapacity == '11') { output += "<img src='" + blobStorage + "capacity-icons/11.svg' />"; }
            else if (this.sheetCapacity == '10') { output += "<img src='" + blobStorage + "capacity-icons/10.svg' />"; }
            else if (this.sheetCapacity == '9') { output += "<img src='" + blobStorage + "capacity-icons/9.svg' />"; }
            else if (this.sheetCapacity == '8') { output += "<img src='" + blobStorage + "capacity-icons/8.svg' />"; }
            else if (this.sheetCapacity == '7') { output += "<img src='" + blobStorage + "capacity-icons/7.svg' />"; }
            else if (this.sheetCapacity == '5') { output += "<img src='" + blobStorage + "capacity-icons/5.svg' />"; }

            // output += "</div><div class='feature-icons'></div><div class='description'><p>" + this.CatalogueDesc +"</p></div><ul class='product-features'>";
            output += "</div><div class='feature-icons'></div><ul class='product-features'>";

            $(this.features).each(function () {
                output += "<li>" + this + "</li>";
            });

            output += "</ul><a href='" + this.productPageURL + "' target='_top'><div class='button red'>Shop Online</div></a></div><br class='clear-both' /></div>";

            $('#resulting-products').append(output);
        });
    }

}